import React, { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Typography,
  Card,
  CardContent,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "../../components/icons/DeleteIcon";
import { useTheme } from "@mui/material/styles";
import { getDataWithToken } from "../../services/GetDataService";
import { AuthContext } from "../../context/AuthContext";
import { postDataWithToken } from "../../services/PostDataService";
import { useSnackbar } from "notistack";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ListIcon from "../../components/icons/ListIcon";
import { Link } from "react-router-dom";
import MenuIcon from "../../components/icons/MenuIcon";
import CountryList from "../CountryList";
import PulseLoader from "react-spinners/PulseLoader";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CloseIcon from "@mui/icons-material/Close";
import AddCard from "./AddCard";
import AddNewCardForm from "./AddNewCardForm";
import CardsIcon from "../../components/icons/CardsIcon";
import CardIcon from "../../components/icons/CardIcon";
import { 
  Business as BusinessIcon,
  SwapHoriz as SwapIcon,
  Check as CheckIcon
} from "@mui/icons-material";
import moment from "moment";
const Cards = () => {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const { login, admin_panel_user, logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [cardList, setCardList] = useState([]);
  const [cardMessage, setCardMessage] = useState("");
  const [storeId, setStoreId] = useState("");
  const [defaultLoading, setDefaultLoading] = useState(false);
  const [cardDetails, setCardDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [openAddCard, setOpenAddCard] = useState(false);
  const [storeList, setStoreList] = useState([]);
  const [age, setAge] = useState("");
  const [removeLoading, setRemoveLoading] = useState(false);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [hasStores, setHasStores] = useState(true);

  const handleChange = (event) => {
    setAge(event.target.value);
    getCardList(event.target.value);
  };
  const handleClickOpen = (row) => {
    setCardDetails(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleAddCardClickOpen = () => {
    setOpenAddCard(true);
  };

  const handleAddCardClose = () => {
    setOpenAddCard(false);
  };

  const handleProjectChange = (event) => {
    const projectId = event.target.value;
    const project = storeList.find(store => store.id === projectId);
    if (project) {
      setSelectedProject(project);
      setSelectedStoreId(projectId);
      // Update the admin_panel_user context with selected store ID
      admin_panel_user.selectedStoreId = projectId;
    }
  };

  const loadStores = async () => {
    try {
      let stores = await getDataWithToken(
        "getStoreInformation",
        admin_panel_user,
        logout
      );

      if (stores?.data?.code === 200) {
        if (stores.data?.data?.storeInfo?.length > 0) {
          setStoreList(stores.data.data.storeInfo);
          // Select the first store
          const firstStore = stores.data.data.storeInfo[0];
          setSelectedStoreId(firstStore.id);
          setSelectedProject(firstStore);
          setHasStores(true);
          // Update the admin_panel_user context
          admin_panel_user.selectedStoreId = firstStore.id;
        } else {
          setStoreList([]);
          setSelectedStoreId(null);
          setSelectedProject(null);
          setHasStores(false);
        }
      } else if (stores?.data?.code === 404) {
        setStoreList([]);
        setSelectedStoreId(null);
        setSelectedProject(null);
        setHasStores(false);
      } else {
        setStoreList([]);
        setSelectedStoreId(null);
        setSelectedProject(null);
        setHasStores(false);
      }
    } catch (error) {
      console.error("Error loading stores:", error);
      setStoreList([]);
      setSelectedStoreId(null);
      setSelectedProject(null);
      setHasStores(false);
    }
  };
  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 4; i++) {
      content.push(
        <Grid item lg={3} xl={3}>
          <Skeleton
            variant="rectangular"
            height={240}
            sx={{ borderRadius: "12px" }}
          />
        </Grid>
      );
    }
    return content;
  };
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const onSetDefaultCard = async (row) => {
    setDefaultLoading(true);

    let data = {
      storeId: admin_panel_user.selectedStoreId,
      cardId: row.cardId,
    };

    let response = await postDataWithToken(
      "setDefaultCard",
      data,
      admin_panel_user,
      logout
    );

    if (response.data.code === 200) {
      getCardList();
      handleSnakbarOpen(response.data.message, "success");
    } else {
      handleSnakbarOpen(response.data.message, "error");
    }

    setDefaultLoading(false);
  };
  const onRemoveCard = async (row) => {
    setRemoveLoading(true);

    let data = {
      storeId: admin_panel_user.selectedStoreId,
      cardId: cardDetails.cardId,
    };

    let response = await postDataWithToken(
      "removeCard",
      data,
      admin_panel_user,
      logout
    );

    if (response.data.code === 200) {
      getCardList();
      handleClose();
      handleSnakbarOpen(response.data.message, "success");
    } else {
      handleSnakbarOpen(response.data.message, "error");
    }

    setRemoveLoading(false);
  };
  const getCardList = async () => {
    setLoading(true);
    setCardList([]);
    let cards = await getDataWithToken(
      `getCardList?storeId=${admin_panel_user.selectedStoreId}`,
      admin_panel_user,
      logout
    );

    if (cards.data.status) {
      if (cards.data?.data?.cards.length > 0) {
        setCardList(cards.data.data.cards);
        // setStoreId(storeId);
      } else {
        setCardMessage(cards.data.message);
      }
    } else {
      setCardMessage(cards.data.message);
    }
    setLoading(false);
  };

  const showOtherCardLogo = (cardType) => {
    if (!["american express", "visa", "mastercard"].includes(cardType)) {
      return (
        <Button
          disabled
          style={{
            textAlign: "center",
            padding: "10px 20px",
            background: "#434343",
            // width: "180px",
            borderRadius: "6px",
            position: "absolute",
            right: "40px",
            top: "40px",
            color: "#fff",
          }}
        >
          {cardType}
        </Button>
      );
    } else if (cardType === "american express") {
      return (
        <img
          src="/images/amex.png"
          alt="logo"
          style={{
            position: "absolute",
            right: "40px",
            top: "40px",
          }}
        />
      );
    } else if (cardType === "visa") {
      return (
        <img
          src="/images/visa.png"
          alt="logo"
          style={{
            position: "absolute",
            right: "40px",
            top: "40px",
          }}
        />
      );
    } else if (cardType === "mastercard") {
      return (
        <img
          src="/images/master.png"
          alt="logo"
          style={{
            position: "absolute",
            right: "40px",
            top: "40px",
          }}
        />
      );
    }
    //   row.cardType.toLowerCase() === "visa"
    //     ? `url(/images/visa_card.png)`
    //     : row.cardType.toLowerCase() === "mastercard"
    //     ? `url(/images/master_card.png)`
    //     : row.cardType.toLowerCase() === "american express"
    //     ? `url(/images/american_express_card.png)`
    //     : `url(/images/default_card.png)`,
  };
  useEffect(() => {
    loadStores();
  }, []);

  useEffect(() => {
    if (selectedStoreId) {
      getCardList();
    }
  }, [selectedStoreId]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      {/* Current Project Card */}
      {hasStores && selectedProject && (
        <Card sx={{ 
          backgroundColor: "#fff",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
          borderRadius: "15px",
          border: "1px solid #E5FFFD",
          marginBottom: "1.5rem"
        }}>
          <CardContent>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item xs={12} md={8}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                  <Avatar sx={{ 
                    backgroundColor: "#E5FFFD", 
                    color: "#016363", 
                    width: "50px", 
                    height: "50px" 
                  }}>
                    <BusinessIcon />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ 
                      color: "#016363", 
                      fontWeight: 600,
                      marginBottom: "0.25rem"
                    }}>
                      {selectedProject.storeName}
                    </Typography>
                    <Typography variant="body2" sx={{ 
                      color: "#666",
                      marginBottom: "0.5rem"
                    }}>
                      {selectedProject.storeDesc || "No description provided"}
                    </Typography>
                    <Box sx={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                      <Chip
                        label={`ID: ${selectedProject.id.slice(-8)}`}
                        size="small"
                        sx={{
                          backgroundColor: "#E5FFFD",
                          color: "#016363",
                          fontWeight: 500,
                          fontSize: "0.75rem"
                        }}
                      />
                      <Chip
                        label={`Created: ${moment(selectedProject.storeCreated).format("DD MMM YYYY")}`}
                        size="small"
                        sx={{
                          backgroundColor: "#E5FFFD",
                          color: "#016363",
                          fontWeight: 500,
                          fontSize: "0.75rem"
                        }}
                      />
                      <Chip
                        label="Active"
                        size="small"
                        sx={{
                          backgroundColor: "#E8F5E8",
                          color: "#2E7D32",
                          fontWeight: 500,
                          fontSize: "0.75rem"
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
              
              {storeList.length > 1 && (
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <SwapIcon sx={{ color: "#016363", fontSize: "1.25rem" }} />
                    <FormControl sx={{ minWidth: 200 }} size="small">
                      <InputLabel id="project-switch-label">
                        Switch Project
                      </InputLabel>
                      <Select
                        labelId="project-switch-label"
                        id="project-switch"
                        value={selectedStoreId || ""}
                        label="Switch Project"
                        onChange={handleProjectChange}
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#E5FFFD",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#016363",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#016363",
                          },
                        }}
                      >
                        {storeList.map((project) => (
                          <MenuItem key={project.id} value={project.id}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                              {project.id === selectedStoreId && (
                                <CheckIcon sx={{ fontSize: "1rem", color: "#016363" }} />
                              )}
                              <Typography variant="body2">
                                {project.storeName}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      )}

      {!hasStores ? (
        <Paper sx={{ p: 4, textAlign: "center", marginBottom: "1.5rem" }}>
          <Typography variant="h5" sx={{ color: "#016363", marginBottom: "1rem" }}>
            No Projects Available
          </Typography>
          <Typography variant="body1" sx={{ color: "#666", marginBottom: "2rem" }}>
            You don't have any projects yet. Create your first project to get started with payment cards.
          </Typography>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#016363",
              color: "white",
              "&:hover": {
                backgroundColor: "#014a4a",
              },
            }}
            onClick={() => window.location.href = "/projects"}
          >
            Go to Projects
          </Button>
        </Paper>
      ) : (
        <>
          <Paper sx={{ py: 1, px: 3, mb: 3 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs="auto">
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs="auto">
                {" "}
                <Avatar
                  sx={{
                    width: 44,
                    height: 44,
                    bgcolor: `${theme.palette.primary.light}`,
                  }}
                >
                  <CardsIcon color={theme.palette.primary.main} />
                </Avatar>
              </Grid>
              <Grid item xs="auto">
                <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 500 }}
                >
                  My Cards
                </Typography>

                {/* <Breadcrumbs
                  aria-label="breadcrumb"
                  // className={classes.breadcrumbsStyle}
                >
                  <Link to="/dashboard">Dashboard</Link>

                  <Link to="#">My Cards</Link>
                </Breadcrumbs> */}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs="auto">
            <Breadcrumbs
              aria-label="breadcrumb"
              // className={classes.breadcrumbsStyle}
            >
              <Link to="/dashboard">Dashboard</Link>

              <Link to="#">My Cards</Link>
            </Breadcrumbs>
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Grid container alignItems="center" spacing={3}>
          {!loading && cardList.length < 1 && (
            <Grid item xs={12}>
              {/* {cardMessage} */} No Card Available
            </Grid>
          )}
          {!loading &&
            cardList.length > 0 &&
            cardList.map((row, i) => (
              <Grid item lg={3} xl={3} key={i}>
                {" "}
                <Paper
                  sx={{
                    borderRadius: "12px",
                    boxShadow:
                      "0px 2px 3px 0px rgba(0, 0, 0, 0.10), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)",
                    background: row.isDefault ? "#F0FAE8" : "#fff",
                  }}
                >
                  <Box
                    sx={{
                      height: "180px",
                      background: `url(/images/Card_Lines.svg), linear-gradient(180deg, #F7F9FF 0%, #E4E4E4 100%)`,
                      borderRadius: "12px",
                      position: "relative",
                    }}
                  >
                    <img
                      src="/images/Chip.png"
                      alt="logo"
                      style={{
                        position: "absolute",
                        left: "28px",
                        top: "62px",
                      }}
                    />
                    {showOtherCardLogo(row.cardType.toLowerCase())}
                    <Typography
                      variant="h6"
                      color="#000"
                      sx={{
                        pl: 6.5,
                        pt: 16,
                        fontSize: "18px",
                        fontWeight: 400,
                      }}
                    >
                      **** &nbsp;&nbsp;&nbsp;&nbsp;****
                      &nbsp;&nbsp;&nbsp;&nbsp;**** &nbsp;&nbsp;&nbsp;&nbsp;
                      {row.last4Digit}
                    </Typography>
                  </Box>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ px: 2.5, py: 1.5 }}
                  >
                    <Grid item xs="base">
                      <Typography
                        variant="small"
                        color="#222"
                        sx={{ fontWeight: 600 }}
                      >
                        {/* {row.country} */}
                        {
                          CountryList.find(
                            (country) => country.code === row.country
                          ).name
                        }
                      </Typography>
                    </Grid>
                    <Grid item xs="auto">
                      {row.isDefault ? (
                        <>
                          {" "}
                          <Button
                            // variant="contained"
                            disableElevation
                            startIcon={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                              >
                                <path
                                  d="M4 8.5L6.66353 11.1667L12 5.83333"
                                  stroke="#69CB1C"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            }
                            sx={{
                              textTransform: "none",
                              fontSize: "12px",
                              paddingRight: "12px",
                              paddingLeft: "12px",
                              borderRadius: "100vw",
                              background: "#fff",
                              color: `${theme.palette.success.main} !important`,
                            }}
                            size="small"
                            disabled
                            // onClick={() => onSetDefaultCard(row)}
                          >
                            Selected as default
                          </Button>
                          &nbsp;
                          <IconButton
                            color="error"
                            size="small"
                            sx={{
                              background: `#fff !important`,
                            }}
                            onClick={() => handleClickOpen(row)}
                          >
                            {/* <DeleteIcon color={theme.palette.error.light} /> */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                            >
                              <path
                                d="M14 4.48667C11.78 4.26667 9.54667 4.15333 7.32 4.15333C6 4.15333 4.68 4.22 3.36 4.35333L2 4.48667"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M5.66699 3.81333L5.81366 2.94C5.92033 2.30667 6.00033 1.83333 7.12699 1.83333H8.87366C10.0003 1.83333 10.087 2.33333 10.187 2.94667L10.3337 3.81333"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M12.5669 6.59333L12.1336 13.3067C12.0603 14.3533 12.0003 15.1667 10.1403 15.1667H5.86026C4.00026 15.1667 3.94026 14.3533 3.86693 13.3067L3.43359 6.59333"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6.88672 11.5H9.10672"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6.33301 8.83333H9.66634"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </IconButton>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="contained"
                            color="success"
                            disableElevation
                            sx={{
                              textTransform: "none",
                              fontSize: "12px",
                              paddingRight: "12px",
                              paddingLeft: "12px",
                              borderRadius: "100vw",
                              minWidth: "120px",
                              minHeight: "30px",
                            }}
                            size="small"
                            disabled={defaultLoading}
                            onClick={() => onSetDefaultCard(row)}
                          >
                            {defaultLoading === false && "Set as Default"}
                            <PulseLoader
                              // color={"#353b48"}
                              color={theme.palette.success.main}
                              loading={defaultLoading}
                              size={10}
                              speedMultiplier={0.5}
                            />{" "}
                          </Button>
                          &nbsp;
                          <IconButton
                            color="error"
                            size="small"
                            sx={{
                              background: `#fff !important`,
                            }}
                            onClick={() => handleClickOpen(row)}
                          >
                            {/* <DeleteIcon color={theme.palette.error.light} /> */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                            >
                              <path
                                d="M14 4.48667C11.78 4.26667 9.54667 4.15333 7.32 4.15333C6 4.15333 4.68 4.22 3.36 4.35333L2 4.48667"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M5.66699 3.81333L5.81366 2.94C5.92033 2.30667 6.00033 1.83333 7.12699 1.83333H8.87366C10.0003 1.83333 10.087 2.33333 10.187 2.94667L10.3337 3.81333"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M12.5669 6.59333L12.1336 13.3067C12.0603 14.3533 12.0003 15.1667 10.1403 15.1667H5.86026C4.00026 15.1667 3.94026 14.3533 3.86693 13.3067L3.43359 6.59333"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6.88672 11.5H9.10672"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6.33301 8.83333H9.66634"
                                stroke="#FF4D4C"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </IconButton>
                        </>
                      )}
                    </Grid>
                  </Grid>

                  {/* <Grid
                    container
                    alignItems="flex-end"
                    justifyContent="space-between"
                  >
                    <Grid item xs="auto">
                      <Typography
                        variant="base"
                        color="text.main"
                        sx={{ fontWeight: 600 }}
                      >
                        <Typography variant="small" color="text.fade">
                          Country
                        </Typography>
                        <Typography variant="h6" color="text.light">
                          {row.country}
                        </Typography>
                      </Typography>
                    </Grid>
                    <Grid item xs="auto">
                      {row.isDefault ? (
                        <Typography
                          variant="medium"
                          color="text.light"
                          sx={{ fontWeight: 500 }}
                        >
                          Selected as default
                        </Typography>
                      ) : (
                        <Button
                          variant="contained"
                          disableElevation
                          sx={{
                            textTransform: "none",
                            fontSize: "14px",
                            paddingRight: "12px",
                            paddingLeft: "12px",
                            borderRadius: "100vw",
                          }}
                          onClick={() => onSetDefaultCard(row)}
                        >
                          Set as Default
                        </Button>
                      )}
                    </Grid>
                  </Grid> */}
                </Paper>
                {/* <Typography
                  variant="base"
                  color="text.main"
                  sx={{ fontWeight: 600 }}
                >
                  {row.cardType}
                </Typography> */}
              </Grid>
            ))}
          {loading && pageLoading()}
        </Grid>
        <Box
          sx={{
            mt: 2,
            pt: 2,
            borderTop: `1px solid ${theme.palette.border.main}`,
            textAlign: "right",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            disableElevation
            startIcon={<AddRoundedIcon />}
            sx={{
              textTransform: "none",
              borderRadius: "100vw",
            }}
            // size="small"

            onClick={handleAddCardClickOpen}
          >
            Add New Card
            <PulseLoader
              // color={"#353b48"}
              color={theme.palette.success.main}
              loading={defaultLoading}
              size={10}
              speedMultiplier={0.5}
            />{" "}
          </Button>
        </Box>
      </Paper>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ minWidth: "350px" }}
          >
            You want remove <b>{cardDetails.cardType} </b> card
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            sx={{ color: theme.palette.text.light }}
          >
            Cancel
          </Button>
          <Button
            onClick={onRemoveCard}
            autoFocus
            variant="contained"
            color="error"
            disableElevation
            disabled={removeLoading}
            sx={{ minHeight: "37px", minWidth: "100px" }}
          >
            {removeLoading === false && "Remove"}
            <PulseLoader
              // color={"#353b48"}
              color={theme.palette.error.main}
              loading={removeLoading}
              size={10}
              speedMultiplier={0.5}
            />{" "}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAddCard}
        onClose={handleAddCardClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
      >
        {/* <DialogTitle id="alert-dialog-title" sx={{ mb: 2 }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs="auto">
              <Grid container alignItems="center" spacing={1}>
                <Grid item xs="auto">
                  {" "}
                  <Avatar
                    sx={{
                      width: 44,
                      height: 44,
                      bgcolor: `${theme.palette.primary.light}`,
                    }}
                  >
                    <CardIcon color={theme.palette.primary.main} />
                  </Avatar>
                </Grid>
                <Grid item xs="auto">
                  <Typography
                    variant="base"
                    color="text.main"
                    sx={{ fontWeight: 500 }}
                  >
                    Add New Card
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs="auto">
              <IconButton
                variant="outlined"
                disableElevation
                onClick={handleAddCardClose}
                style={{
                  background: theme.palette.border.main,
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle> */}
        <DialogContent
          sx={{ maxWidth: "500px", minWidth: "500px", py: 3, px: 5.5 }}
        >
          {/* <AddCard
            handleAddCardClose={handleAddCardClose}
            getCardList={getCardList}
          /> */}
          <AddNewCardForm
            handleAddCardClose={handleAddCardClose}
            getCardList={getCardList}
            cardList={cardList}
          />
        </DialogContent>
        {/* <DialogActions>
          <Button
            variant="outlined"
            disableElevation
            autoFocus
            startIcon={<CloseIcon fontSize="small" />}
            onClick={handleClose}
            sx={{ minWidth: "160px" }}
          >
            Close  
          </Button>
        </DialogActions> */}
      </Dialog>
        </>
      )}
    </>
  );
};

export default Cards;
